<template>
  <div class="desktop-display-mobile" v-if="show">
    <slot></slot>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { is_desktop_display_mobile } from './index'

  export default {
    name: 'desktop-display-mobile',
    computed: {
      ...mapState(['isMobile', 'gameName']),
      show() {
        return is_desktop_display_mobile(this.isMobile, this.gameName)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .desktop-display-mobile {
    width: 1080px;
  }
</style>
